import { render, staticRenderFns } from "./AnnotationListElement.vue?vue&type=template&id=cc4039ba&scoped=true"
import script from "./AnnotationListElement.vue?vue&type=script&lang=ts"
export * from "./AnnotationListElement.vue?vue&type=script&lang=ts"
import style0 from "./AnnotationListElement.vue?vue&type=style&index=0&id=cc4039ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4039ba",
  null
  
)

export default component.exports